import { render, staticRenderFns } from "./VSLLabelRowRenderer.vue?vue&type=template&id=028d3676"
import script from "./VSLLabelRowRenderer.vue?vue&type=script&lang=js"
export * from "./VSLLabelRowRenderer.vue?vue&type=script&lang=js"
import style0 from "./VSLLabelRowRenderer.vue?vue&type=style&index=0&id=028d3676&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports